import { Component, input } from '@angular/core';
import { SharedModule } from '@app/modules/shared.module';
import { DevPsychomoteur, FirstDA } from '@app/models/carnet-liaison';
import {
  getFirstDate,
  formatFirstDate,
  getItemsToShow,
} from '../../carnet-liaison.utils';
import {
  MOTRICITE_GLOBALE_LABELS,
  MOTRICITE_FINE_LABELS,
  AUTONOMIE_LABELS,
} from '../../carnet-liaison.constants';

@Component({
  selector: 'app-carnet-dev-psychomoteur',
  templateUrl: './carnet-dev-psychomoteur.component.html',
  styleUrl: './carnet-dev-psychomoteur.component.scss',
  standalone: true,
  imports: [SharedModule],
})
export class CarnetDevPsychomoteurComponent {
  data = input<DevPsychomoteur | null>(null);
  firstDA = input<FirstDA | null>(null);
  selectedDate = input<Date | null>(null);

  readonly motriciteGlobaleLabels = MOTRICITE_GLOBALE_LABELS;
  readonly motriciteFineLabels = MOTRICITE_FINE_LABELS;
  readonly autonomieLabels = AUTONOMIE_LABELS;

  formatFirstDate = formatFirstDate;

  getFirstDate(fieldName: string, optionKey: string): string | null {
    return getFirstDate(this.firstDA(), 'DA_devPsychomoteur', fieldName, optionKey);
  }

  getVisibleItems(obj: Record<string, boolean> | null | undefined, labels: Record<string, string>, fieldName: string): { label: string; key: string }[] {
    return getItemsToShow(obj ?? {}, labels, this.firstDA(), 'DA_devPsychomoteur', fieldName, this.selectedDate());
  }
}
